import config from './../../config/config';

const REMOTE_API_MODE = false;
if( REMOTE_API_MODE ){ console.warn('REMOTE API MODE');}

export default class ApiService {

	static get $inject(){
		return ['APP_CONFIG', '$location'];
	}

	constructor(APP_CONFIG, $location){
		let host = $location.host();
		//this._api = host === 'localhost' ? 'http://localhost:8080/api' : 'http://40.114.250.155:8080/api';
		//this._api = host === 'localhost' && !REMOTE_API_MODE ? 'http://localhost:8080/api' : 'http://panel.crowcloud.com:8080/api';
		//this._api = 'http://api.crowcloud.xyz:8000';
		let cfg = _.defaults(APP_CONFIG, config);
		this._api = cfg.apiURL;
		// this._api = "http://localhost";
	}

	get api(){
		return this._api;
	}

	get errors(){
		return {
			status: {
				name: 'status',
				type: 'String',
				description: 'HTTP response <a href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes" target="_blank">status code</a>'
			},
			state: { name: 'state', type: 'String', description: 'State of operation' },
			message: { name: 'message', type: 'String', description: 'Optional error description ' }
		};
	}

	get successes(){
		return {
			status: {
				name: 'status',
				type: 'String',
				description: 'HTTP response <a href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes" target="_blank">status code</a>'
			},
			state: { name: 'state', type: 'String', description: 'State of operation' },
			message: { name: 'message', type: 'String', description: 'Optional description ' }
		};
	}
}



/** WEBPACK FOOTER **
 ** ./src/services/api/api.service.js
 **/